import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'
import { VODTitleWidget } from 'htv-lib'
import { PageService } from '../../services/page.service'
import { Subscription } from 'rxjs'
import { PAGE_KEY } from '../../constants/page.constants'
import { VODVideo } from '../../interfaces/vod'
import { VODService } from '../../services/vod.service'

@Component({
  selector: 'app-vod-title',
  standalone: true,
  imports: [CommonModule, DynamicTextComponent],
  templateUrl: './vod-title.component.html',
  styleUrls: [],
})
export class VODTitleComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription()
  @Input() config!: VODTitleWidget

  text = ''

  constructor(
    private pageService: PageService,
    private vodService: VODService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_VOD)?.subscribe((vod: VODVideo) => {
        if (vod) {
          const vodLang = this.vodService.getVODLang(vod)
          this.text = vodLang?.title ?? ''
        } else {
          this.text = ''
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
